import { cn } from "../../lib/utils";
import { AnimatePresence, motion } from "framer-motion";

import { useState } from "react";
import { Meteors } from "./Meteors";
import { HoverBorderGradient } from "./hover-border-gradient";
import { ArrowUpRight } from "lucide-react";

export const HoverEffect = ({ items, className }) => {
  let [hoveredIndex, setHoveredIndex] = useState(null);

  return (
    <div
      className={cn(
        "grid grid-cols-1 md:grid-cols-2  lg:grid-cols-3  py-10",
        className
      )}
    >
      {items.map((item, idx) => (
        <a
          href={item.clickable ? item.link : "#"}
          key={`${item.title}-${idx}`}
          className={cn(
            "relative group block p-2 h-full w-full",
            !item.clickable && "cursor-default "
          )}
          onClick={(e) => {
            if (!item.clickable) e.preventDefault(); // Disable navigation
          }}
          onMouseEnter={() => setHoveredIndex(idx)}
          onMouseLeave={() => setHoveredIndex(null)}
        >
          <AnimatePresence>
            {hoveredIndex === idx && (
              <motion.span
                className="absolute inset-0 h-full w-full bg-slate-800/[0.8] block rounded-none rounded-tr-[2.5rem] rounded-bl-[2.5rem]"
                layoutId="hoverBackground"
                initial={{ opacity: 0 }}
                animate={{
                  opacity: 1,
                  transition: { duration: 0.15 },
                }}
                exit={{
                  opacity: 0,
                  transition: { duration: 0.15, delay: 0.2 },
                }}
              />
            )}
          </AnimatePresence>
          <Card clickable={item.clickable}>
            <CardNetworkImage>{item.NetworkImage}</CardNetworkImage>
            <CardTitle>{item.title}</CardTitle>
            <CardDescription>{item.description}</CardDescription>
          </Card>
        </a>
      ))}
    </div>
  );
};


export const Card = ({ className, children,clickable = true }) => {
  return (
    <div
      className={cn(
        "rounded-none rounded-tr-[2.5rem] rounded-bl-[2.5rem] h-full w-full p-4 overflow-hidden bg-black border border-white/[0.2] group-hover:border-slate-700 flex flex-col items-start relative z-20",
        className
      )}
    >
      <div className="flex h-5 w-5 items-center justify-center rounded-full border border-gray-500">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className="h-2 w-2 text-gray-300"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M4.5 4.5l15 15m0 0V8.25m0 11.25H8.25"
          />
        </svg>
      </div>
      <div className="relative z-50">
        <div className="p-4">{children}</div>
      </div>
      {/* <button className="rounded-lg mt-auto border border-gray-500 px-4 py-1 text-gray-300">
        Explore
      </button> */}
      <HoverBorderGradient
        containerClassName="rounded-full mt-auto ms-auto"
        as="button"
         disabled={!clickable}
        onClick={(e) => {
          if (!clickable) e.preventDefault();
        }}
        className={cn(
          "group bg-white/5 backdrop-blur-md text-white ps-4 text-sm pe-1 py-1 rounded-full transition duration-200 inline-flex items-center gap-2 leading-normal space-x-2",
          !clickable && "cursor-default pointer-events-none "
        )}
      >
        Explore
        <span className="bg-white text-slate-900 p-1 rounded-full transition-transform duration-300 group-hover:rotate-[45deg]">
          <ArrowUpRight size={15} />
        </span>
      </HoverBorderGradient>
      <Meteors number={5} />
    </div>
  );
};
export const CardTitle = ({ className, children }) => {
  return (
    <h4 className={cn("text-zinc-100 font-bold tracking-wide", className)}>
      {children}
    </h4>
  );
};
export const CardNetworkImage = ({ className, children }) => {
  
  return (
    <img
      src={children}
      alt="Network"
      width={100}
      height={100}
      className={cn("text-zinc-100 font-bold tracking-wide", className)}
    />
  );
};
export const CardDescription = ({ className, children }) => {
  return (
    <p
      className={cn(
        "mt-4 text-zinc-400 tracking-wide leading-relaxed text-sm",
        className
      )}
    >
      {children}
    </p>
  );
};
